module.exports = __webpack_public_path__ + "img/The Life of the World to Come.0359af03.jpg";